import { win } from "./common-namespaces-client-CHyZgmlk.mjs";
const otto = win.otto ?? {};
export {
  otto
};
/*                                                     */
